// src/components/PageMeta.tsx
//
// Per-page <head> metadata using react-helmet-async.
// Replaces Next.js `export const metadata` and `generateMetadata()`.

import { Helmet } from "react-helmet-async";

interface PageMetaProps {
  title?: string;
  description?: string;
  canonical?: string;
  ogType?: string;
  ogImage?: string;
  noIndex?: boolean;
  children?: React.ReactNode;
}

export function PageMeta({
  title,
  description,
  canonical,
  ogType = "website",
  ogImage = "/og-image.png",
  noIndex = false,
  children,
}: PageMetaProps) {
  const fullTitle = title ? `${title} | FHIRfly` : "FHIRfly - Healthcare Data APIs for Agents and Apps";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {canonical && <link rel="canonical" href={canonical} />}
      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:title" content={title || fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={ogImage} />
      {canonical && <meta property="og:url" content={canonical} />}
      <meta property="og:site_name" content="FHIRfly" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title || fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={ogImage} />

      {children}
    </Helmet>
  );
}
